const CustomerCodeType = Symbol();

export class CustomerCode {
    [CustomerCodeType]: any;
    readonly value: string;

    private constructor(customerCode: string) {
        this.value = customerCode;
    }

    static fromString(customerCode: string) {
        return new CustomerCode(customerCode);
    }
}

